import { render, staticRenderFns } from "./InterviewCard.vue?vue&type=template&id=55f96d6b&"
import script from "./InterviewCard.vue?vue&type=script&lang=ts&"
export * from "./InterviewCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports